import { getApp, getApps, initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
  TENANT_BOOTSTRAP_ERROR_CODES,
  TenantBootstrapError,
} from "./bootstrapErrors";

const CENTRAL_APP_NAME = "oceanlogix-central";
const REQUIRED_CENTRAL_CONFIG_FIELDS = [
  "apiKey",
  "authDomain",
  "projectId",
  "storageBucket",
  "messagingSenderId",
  "appId",
];

const getCentralFirebaseConfig = () => ({
  apiKey: process.env.REACT_APP_OCEANLOGIX_CENTRAL_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_OCEANLOGIX_CENTRAL_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_OCEANLOGIX_CENTRAL_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_OCEANLOGIX_CENTRAL_FIREBASE_STORAGE_BUCKET,
  messagingSenderId:
    process.env.REACT_APP_OCEANLOGIX_CENTRAL_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_OCEANLOGIX_CENTRAL_FIREBASE_APP_ID,
  measurementId:
    process.env.REACT_APP_OCEANLOGIX_CENTRAL_FIREBASE_MEASUREMENT_ID,
});

export const getCentralFirebaseServices = () => {
  const config = getCentralFirebaseConfig();
  const missingFields = REQUIRED_CENTRAL_CONFIG_FIELDS.filter(
    (field) => !String(config[field] || "").trim()
  );

  if (missingFields.length > 0) {
    throw new TenantBootstrapError(
      TENANT_BOOTSTRAP_ERROR_CODES.CENTRAL_FIREBASE_CONFIG_INVALID,
      "Central Firebase config is missing required fields.",
      { missingFields }
    );
  }

  const app =
    getApps().find((candidate) => candidate.name === CENTRAL_APP_NAME) ||
    initializeApp(config, CENTRAL_APP_NAME);

  return {
    app,
    db: getFirestore(app),
  };
};

export const getCentralFirebaseApp = () => {
  try {
    return getApp(CENTRAL_APP_NAME);
  } catch {
    return getCentralFirebaseServices().app;
  }
};
